import { z } from 'zod';

import { listSearchSchema } from '@/shared/patterns/list-search';

import { MOVEMENT_FILTERS, SUSPENSE_LIST_FILTERS } from './suspense-account.filters';

// Leve de propósito: entra no arquivo da rota (bundle inicial). Só zod e os filtros.

/** Gavetas da lista pela URL (U26): "Novo Bolsão" e o painel de filtros do iPhone. */
export const SUSPENSE_LIST_SHEETS = ['novo', 'filtros'] as const;

/** Lista do Bolsão: página, tamanho, os filtros do legado e a gaveta. */
export const suspenseAccountListSearch = listSearchSchema({
  ...SUSPENSE_LIST_FILTERS.shape,
  sheet: z.enum(SUSPENSE_LIST_SHEETS).optional().catch(undefined),
});
export type SuspenseAccountListSearch = z.output<typeof suspenseAccountListSearch>;

/** Gavetas do detalhe: Lançar valor, Remover valor, Editar e o painel de filtros do extrato no iPhone. */
export const SUSPENSE_DETAIL_SHEETS = ['lancar', 'remover', 'editar', 'filtros'] as const;
export type SuspenseDetailSheet = (typeof SUSPENSE_DETAIL_SHEETS)[number];

/** Detalhe: a página e os filtros do extrato e a gaveta aberta. */
export const suspenseAccountDetailSearch = listSearchSchema({
  ...MOVEMENT_FILTERS.shape,
  sheet: z.enum(SUSPENSE_DETAIL_SHEETS).optional().catch(undefined),
});
export type SuspenseAccountDetailSearch = z.output<typeof suspenseAccountDetailSearch>;
